import React from 'react'
import Footer from '../../../components/Landing/Footer'
import { SEO } from '../../../components/SEO'

const StaySafe = () => {
  return (
    <>
    <SEO 
      title="Stay Safe - Safety Guidelines"
      description="Learn how to stay safe while using WorldoTutor. Discover tips to protect yourself from scams and ensure secure transactions on our platform."
      keywords="safety, stay safe, online safety, fraud protection, secure payments"
      url="/stay-safe"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Stay Safe - WorldoTutor Safety Guidelines',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Stay Safe - WorldoTutor Safety Guidelines'
        }
      }}
    />

    <div className="p-4 md:p-8 lg:p-12 container  mx-auto">
       <h1 className=' px-6 text-4xl font-semibold'>Stay-Safe</h1>
      <div className=" bg-white p-6 rounded-lg shadow-sm">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
          How to protect yourself in the global market?
        </h2>
        <p className="mb-6 text-gray-700">
          Well, we already know that most of our students and teachers are honest and reliable. We try our best to keep the website clean and safe. However, it's not possible for us to keep a tap or verify everyone's credentials or intentions. That's why we appeal our members to remain vigilant against any sort of financial or physical loss while dealing with strangers.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Beware of scammers
        </h2>
        <p className="mb-6 text-gray-700">
          Here's a list of recognized scammers. Please ensure you aren't dealing with any of them. Also, from time to time, we update this list.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Make your payment process secure
        </h2>
        <ul className="list-disc list-inside space-y-3 text-gray-700">
          <li>
            Pay and receive payments through World O'Tutor. When you make payment through us, we ensure to keep it protected.
          </li>
          <li>
            If you choose to pay outside our portal, do it via PayPal: they offer fraud protection.
          </li>
          <li>
            If the payment terms are settled outside of our domain, start work only after getting at least a partial advance payment.
          </li>
        </ul>
      </div>
    </div>

      <div className='bg-neutralBlack'>
        <Footer/>
      </div>
      </>
  )
}

export default StaySafe
